/**
 * @desc 查询熟料生产月计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthClinkerResponse>> {
  return defHttp.post({
    url: '/web/plan/month/queryPlanClinker',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthClinkerResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/month/queryPlanClinker',
    data,
  });
}
